import { SVGProps } from 'react';

export const RivalsFist = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 5.65625C7.75 5.5625 7.5 5.5 7.25 5.5H6V1C6 0.46875 6.4375 0 7 0C7.53125 0 8 0.46875 8 1V5.65625ZM5 5.5H3.25C3.15625 5.5 3.0625 5.53125 3 5.53125V2C3 1.46875 3.4375 1 4 1C4.53125 1 5 1.46875 5 2V5.5ZM10 6C9.4375 6 9 5.5625 9 5V2C9 1.46875 9.4375 1 10 1C10.5312 1 11 1.46875 11 2V5C11 5.5625 10.5312 6 10 6ZM13 3C13.5312 3 14 3.46875 14 4V6C14 6.5625 13.5312 7 13 7C12.4375 7 12 6.5625 12 6V4C12 3.46875 12.4375 3 13 3ZM11.9375 7.71875C12.25 7.90625 12.5938 8 13 8C13.3438 8 13.6875 7.90625 14 7.75V9.78125C14 11.2812 13.1875 12.5938 12 13.3438V16H5V13.5938L3.3125 12.375C2.5 11.75 2 10.7812 2 9.75V7.75C2 7.0625 2.53125 6.5 3.25 6.5H7.25C7.9375 6.5 8.5 7.0625 8.5 7.75C8.5 8.46875 7.9375 9 7.25 9H5C4.71875 9 4.5 9.25 4.5 9.5C4.5 9.78125 4.71875 10 5 10H7.25C8.46875 10 9.5 9 9.5 7.75C9.5 7.46875 9.40625 7.15625 9.3125 6.875C9.53125 6.96875 9.75 7 10 7C10.4062 7 10.7812 6.875 11.125 6.65625C11.25 7.09375 11.5625 7.46875 11.9375 7.71875Z" />
  </svg>
);
